import { createElement, ReactNode, ForwardedRef } from 'react';
import * as motion from 'motion/react-client';
import { fadeInUp } from '@/animations';
import classNames from 'classnames';

export type AnimationProps = {
  animate?: boolean;
  animation?: object | ((...args: any[]) => any);
};

export interface IBoxProps extends React.HTMLAttributes<HTMLElement>, AnimationProps {
  tag?: string;
  className?: string;
  children?: ReactNode;
  ref?: ForwardedRef<HTMLElement>;
}

const Box = ({ tag = 'div', animation = fadeInUp, animate = true, children, className, ...props }: IBoxProps) => {
  const _animate = animate && animation;
  const _motion = _animate ? animation : null;

  return createElement(
    _animate ? getMotionTag(tag) : tag,
    {
      ...props,
      className: classNames(className, 'print:!opacity-100 print:!transform-none animation-text'),

      ...(_animate ? _motion : {}),
    },
    children,
  );
};

const getMotionTag = (tag: string) => {
  const tags: { [key: string]: any } = {
    div: motion.div,
    section: motion.section,
    footer: motion.footer,
    header: motion.header,
    picture: motion.picture,
    span: motion.span,
  };

  return tags[tag] || motion.div;
};

export default Box;
